import React from 'react';

const CallToAction = () => {
  // Função para criar o link do WhatsApp
  const createWhatsAppLink = (message) => {
    const phoneNumber = "5537998630380"; // Adicionando o código do país (55) antes do número
    const encodedMessage = encodeURIComponent(message);
    return `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
  };

  return (
    <section id="agendar" className="py-20 bg-primary-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-8">
            Rompa ciclos. Reconstrua sua história.
          </h2>
          
          <p className="text-xl mb-12">
            Proclame liberdade à sua mente cativa.
          </p>
          
          <div className="flex flex-col md:flex-row gap-6 justify-center">
            <a 
              href={createWhatsAppLink("Olá, estou pronto para começar minha jornada de transformação emocional.")} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="btn btn-accent text-lg px-10 py-4"
              onClick={(e) => {
                window.open(createWhatsAppLink("Olá, estou pronto para começar minha jornada de transformação emocional."), '_blank');
              }}
            >
              COMEÇAR MINHA JORNADA
            </a>
            <a 
              href={createWhatsAppLink("Olá, gostaria de agendar uma palestra com Kelton Oliveira.")} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="btn btn-secondary text-lg px-10 py-4"
              onClick={(e) => {
                window.open(createWhatsAppLink("Olá, gostaria de agendar uma palestra com Kelton Oliveira."), '_blank');
              }}
            >
              AGENDE UMA PALESTRA
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
